export default __webpack_public_path__ + "static/logo-07-c483a90f4974eafb72da7f3752d9a903.png";